module.exports = __webpack_public_path__ + "static/img/bg_en.31b5636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bts-2026-sale/bg_en.png
// module id = 0KEV
// module chunks = 2